import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CompanyClickedEvent, GlobalEventService, IccidClickedEvent } from 'src/app/core/services/utelize/general/global-event-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { LocationServicesAccessService } from 'src/app/core/services/utelize/access/location-services/location-services-access.service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { MdmAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-access.service';
import { MdmHealthReportAccessService } from 'src/app/core/services/utelize/access/device-management/mdm-health-report-access.service';
import { MenuItem } from './menu.model';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { SignalsAccessService } from 'src/app/core/services/utelize/access/signals/signals-access.service';
import { Subscription } from 'rxjs';
import { TopBarMenuComponent } from './menu';
import { TranslateService } from '@ngx-translate/core';
import { TravelRiskManagementAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/travel-risk-management-access.service';
import { WarningModalNRFormComponent } from 'src/app/forms-modal-confirmation/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-horizontal-topbar',
  templateUrl: './horizontal-topbar.component.html',
  styleUrls: ['./horizontal-topbar.component.scss']
})

export class HorizontalTopbarComponent implements OnDestroy, OnInit {

  @Output() mobileMenuButtonClicked = new EventEmitter();

  @ViewChild('companyModalForm',    { static: false }) companyModalForm!   : CompanyModalFormComponent;
  @ViewChild('manageEsimModalForm', { static: false }) manageEsimModalForm!: ManageEsimModalFormComponent;
  @ViewChild('sideMenu')                               sideMenu!           : ElementRef;
  @ViewChild('warningModalForm',    { static: false }) warningModalForm!   : WarningModalNRFormComponent;

  private accessGuidsChangedSub    : Subscription | undefined;
  private companyClickedOnCancelled: (() => void) | undefined;
  private companyClickedOnSaved    : ((sureSimCompanyId: number | undefined) => void) | undefined;
  private companyClickedSub        : Subscription | undefined;
  private iccidClickedOnCancelled  : (() => void) | undefined;
  private iccidClickedOnSaved      : (() => void) | undefined;
  private iccidClickedSub          : Subscription | undefined;
  private menuComponent            : TopBarMenuComponent;
  private modeSubscription         : Subscription | undefined;

  public isPlatformModeInview: boolean   =environment.platformModeInview;
  public menuItems           : MenuItem[]=[];

  constructor(
    private authenticationService            : AuthenticationService,
    private componentAccessUserService       : ComponentAccessUserService,
    private configSystemService              : ConfigSystemService,
    private exceptionsService                : ExceptionsService,
    private globalEventService               : GlobalEventService,
    private locationServicesAccessService    : LocationServicesAccessService,
    private mdmAccessService                 : MdmAccessService,
    private mdmHealthReportAccessService     : MdmHealthReportAccessService,
    private platformInviewService            : PlatformInviewService,
    private riskIntelligenceAccessService    : RiskIntelligenceAccessService,
    private signalsAccessService             : SignalsAccessService,
    private travelRiskManagementAccessService: TravelRiskManagementAccessService,

    public translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    this.menuComponent=new TopBarMenuComponent(this.authenticationService,
                                               this.componentAccessUserService,
                                               this.configSystemService,
                                               this.exceptionsService,
                                               this.locationServicesAccessService,
                                               this.mdmAccessService,
                                               this.mdmHealthReportAccessService,
                                               this.platformInviewService,
                                               this.riskIntelligenceAccessService,
                                               this.signalsAccessService,
                                               this.travelRiskManagementAccessService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      //CRN_20251222 - Config params are loaded in AppComponent.ngOnInit()

      // const data=await firstValueFrom(this.configSystemService.getEncrypted()
      //                  .pipe(
      //                    catchError((error) => throwError(() => new Error(this.exceptionsService.formatHttpError(error))))
      //                  ));

      // this.configSystemService.allParamsAndValues=data;

      this.menuItems=this.menuComponent.Menu();

      this.menuComponent.Init().then(() => {
        this.menuItems=this.menuComponent.Menu();
      });

      this.companyClickedSub=this.globalEventService.companyClicked$.subscribe({
        next : (event: CompanyClickedEvent) => {
          if (this.companyModalForm.isCompanyFormOpen) {
            this.warningModalForm.openForm("Company Form Already Open", "A company form is already open, close this form to return to it");
          } else {
            this.companyClickedOnCancelled=event.onCancelled;
            this.companyClickedOnSaved    =event.onSaved;
            this.companyModalForm.openForm(event.companyId, event.openOnLocationTab);
          }
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });

      this.iccidClickedSub=this.globalEventService.iccidClicked$.subscribe({
        next : (event: IccidClickedEvent) => {
          if (this.manageEsimModalForm.isSimFormOpen) {
            this.warningModalForm.openForm("Manage SIM Already Open", "A manage ICCID form is already open, close this form to return to it");
          } else {
            this.iccidClickedOnCancelled=event.onCancelled;
            this.iccidClickedOnSaved    =event.onSaved;
            this.manageEsimModalForm.openFormByIccid(event.iccid, event.openOnLocationTab);
          }
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });

      //CRN_20260407 - Refresh menu when platform mode changes

      if (this.isPlatformModeInview) {
        this.modeSubscription=this.platformInviewService.mode().subscribe(() => {
          this.menuItems=this.menuComponent.Menu();
        });
      }

      this.accessGuidsChangedSub=this.globalEventService.accessGuidsChanged$.subscribe({
        next : () => {
          this.menuItems=this.menuComponent.Menu();
        },
        error: error => { this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.accessGuidsChangedSub?.unsubscribe();
      this.companyClickedSub?.unsubscribe();
      this.iccidClickedSub?.unsubscribe();
      this.modeSubscription?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  /***
   * Activate droup down set
   */
   ngAfterViewInit() {
    this.initActiveMenu();
  }

  removeActivation(items: any) {   
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  // remove active items of two-column-menu
  activateParentDropdown(item: any) { // navbar-nav menu add active
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {      
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
        parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active")); 
      this.removeActivation(activeItems);
      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  toggleSubItem(event: any) {
    if(event.target && event.target.nextElementSibling)
      event.target.nextElementSibling.classList.toggle("show");
  };

  toggleItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');    
    
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    (isMenu) ? isMenu.classList.add('show') : null;

    const ul = document.getElementById("navbar-nav");
    if(ul){
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    } 
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  public onCompanyDataSaved(sureSimCompanyId: number | undefined): void {
    try {
      this.companyClickedOnCancelled=undefined;
      this.companyClickedOnSaved?.(sureSimCompanyId);
      this.companyClickedOnSaved    =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCompanyFormCancelled(): void {
    try {
      this.companyClickedOnSaved    =undefined;
      this.companyClickedOnCancelled?.();
      this.companyClickedOnCancelled=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onIccidFormCancelled(): void {
    try {
      this.iccidClickedOnSaved    =undefined;
      this.iccidClickedOnCancelled?.();
      this.iccidClickedOnCancelled=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onIccidFormSaved(): void {
    try {
      this.iccidClickedOnCancelled=undefined;
      this.iccidClickedOnSaved?.();
      this.iccidClickedOnSaved    =undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

}
